<template>
<h1>Hello Lists</h1>
</template>

<script>
export default {
  name: "ListView"
}
</script>

<style scoped>

</style>